import request from '@/utils/request'

// 결제 내역 조회
export function getPaymentHistory(params, isNotify) {
  return request({
    url: `/api/getPaymentHistory`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 결제내역 상세 조회(toss)
export function getTossPaymentHistoryDetail(params, isNotify) {
  return request({
    url: `/api/getTossPaymentHistoryDetail`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

//계약서 출력
export function getContractReport(param, isNotify) {
  let responseType = 'blob'
  return request({
    url: '/api/getContractReport',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' },
    responseType: responseType
  })
}